import type {ReactElement} from 'react';
import type {QREmailInput} from '@Libraries/qr-code/qr-code.types';
import {QRPayloadField} from '@Libraries/qr-code/qr-code.types';
import {QRField} from '@Components/qr-code-generator/components/qr-field/qr-field';
import type {QRFormProps} from '@Components/qr-code-generator/qr-code-generator.types';

export function QREmailForm({input, issues, onPatch}: QRFormProps<QREmailInput>): ReactElement {
  return (
    <>
      <QRField
        label={window.i18next.t('pmwjs_qr_generator_email_to_label')}
        placeholder={window.i18next.t('pmwjs_qr_generator_email_to_placeholder')}
        value={input.emailAddress}
        field={QRPayloadField.EMAIL_ADDRESS}
        issues={issues}
        onValueChange={(emailAddress): void => {
          onPatch({emailAddress});
        }}
      />
      <QRField
        label={window.i18next.t('pmwjs_qr_generator_email_subject_label')}
        placeholder={window.i18next.t('pmwjs_qr_generator_email_subject_placeholder')}
        value={input.subject}
        onValueChange={(subject): void => {
          onPatch({subject});
        }}
      />
      <QRField
        label={window.i18next.t('pmwjs_qr_generator_email_body_label')}
        placeholder={window.i18next.t('pmwjs_qr_generator_email_body_placeholder')}
        value={input.body}
        isMultiline
        onValueChange={(body): void => {
          onPatch({body});
        }}
      />
    </>
  );
}
